import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

// Layout Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Homepage Components
import HeroSection from './components/HeroSection';
import AboutUs from './components/AboutUs';
import OurMission from './components/OurMission';
import CoffeeTypes from './components/CoffeeTypes';
import TheJourney from './components/TheJourney';
import TwoColumnFeature from './components/TwoColumnFeature';
import ParallaxSection from './components/ParallaxSection';
import Gallery from './components/Gallery';
import WholesaleMarket from './components/WholesaleMarket';
import ContactUs from './components/ContactUs';

// Pages
import CoffeeTypesPage from './pages/CoffeeTypesPage';
import ProcessPage from './pages/ProcessPage';
import ProductsPage from './pages/ProductsPage';
import VisionPage from './pages/VisionPage';
import ContactPage from './pages/ContactPage';

// ────────────────────────────────────────────────────────────────────
// Homepage — the original single-page scrolling experience, enhanced
// ────────────────────────────────────────────────────────────────────
function HomePage() {
  useEffect(() => {
    document.title = 'Savana Sips | Your Cup! Your Day! | African Specialty Coffee';
  }, []);

  return (
    <>
      <HeroSection />
      <AboutUs />
      <OurMission />
      <CoffeeTypes />
      <TheJourney />
      <TwoColumnFeature />
      <ParallaxSection />
      <Gallery />
      <WholesaleMarket />
      <ContactUs />
    </>
  );
}

// ────────────────────────────────────────────────────────────────────
// ScrollToTop — ensures each route renders from the top
// ────────────────────────────────────────────────────────────────────
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// ────────────────────────────────────────────────────────────────────
// App Layout — wraps shared Navbar + Footer around all routes
// ────────────────────────────────────────────────────────────────────
function AppLayout() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/coffee-types" element={<CoffeeTypesPage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Fallback — redirect unknown routes to home */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

// ────────────────────────────────────────────────────────────────────
// Root App
// ────────────────────────────────────────────────────────────────────
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
